import { useEffect } from 'react'
import { useLocation } from '@reach/router'
import { useAudioContext } from './AudioProvider'
import { isPathActive } from 'lib/urls'

/**
 * Coordinates audio playback based on route navigation.
 * Stops audio when navigating away from /meet/ routes,
 * and resumes when navigating back.
 */
export const AudioRouteCoordinator = () => {
  const location = useLocation()
  const { playAudioProgrammatically, stopAudioProgrammatically } =
    useAudioContext()

  useEffect(() => {
    const isOnMeetRoute = isPathActive('/meet/', location.pathname)

    if (isOnMeetRoute) {
      playAudioProgrammatically()
    } else {
      stopAudioProgrammatically()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ignore playback functions so they don't have to be stable
  }, [location.pathname])

  return null
}
